import { Transition, createBlock, createElementVNode, defineComponent, normalizeClass, onBeforeUnmount, onMounted, openBlock, ref, toDisplayString, withCtx } from "vue";

//#region Toast.vue?vue&type=script&setup=true&lang.ts
const _hoisted_1 = { class: "toast-emoji" };
const _hoisted_2 = ["innerHTML"];
var Toast_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "Toast",
	props: {
		content: {},
		emoji: { default: "" },
		timeoutToDismiss: { default: 1e4 }
	},
	emits: ["close"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emits = __emit;
		const visible = ref(true);
		let timer = null;
		function dismiss() {
			visible.value = false;
			emits("close");
		}
		onMounted(() => {
			timer = setTimeout(dismiss, props.timeoutToDismiss);
		});
		onBeforeUnmount(() => {
			if (timer) clearTimeout(timer);
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Transition, { name: "toast-fade" }, {
				default: withCtx(() => [createElementVNode("section", {
					role: "complementary",
					"aria-labelledby": "banner-heading",
					class: normalizeClass(["av-toast", !visible.value ? "toast-hidden" : ""])
				}, [
					createElementVNode("span", _hoisted_1, toDisplayString(_ctx.emoji), 1),
					createElementVNode("span", {
						class: "toast-message",
						id: "banner-heading",
						innerHTML: _ctx.content
					}, null, 8, _hoisted_2),
					createElementVNode("button", {
						class: "toast-close",
						type: "button",
						onClick: dismiss,
						"aria-label": "Close toast",
						tabindex: "0"
					}, [..._cache[0] || (_cache[0] = [createElementVNode("i", { class: "icon-heavy-close-1" }, null, -1)])])
				], 2)]),
				_: 1
			});
		};
	}
});

//#endregion
export { Toast_vue_vue_type_script_setup_true_lang_default as Toast };